import { BooleanInput, Edit, SimpleForm, TextInput } from "@/components/admin"
import { ReactElement } from "react"

const BlogEdit = (): ReactElement => {
  return (
    <Edit mutationMode="optimistic">
      <SimpleForm>
        <TextInput source="title" label="Titre" />
        <TextInput source="content" label="Contenu" multiline rows={5} />
        <TextInput source="image" label="URL de l'image" />
        <BooleanInput source="published" label="Publié" />
      </SimpleForm>
    </Edit>
  )
}

export default BlogEdit
